<template>
  <main>
    <div class="row">
      <div class="col-12 col-lg-5 align-self-center">
        <div class="d-flex align--center text--medium text--normal-size">
          <span class="w-100">{{ resourceData.equipmentName }}</span>
          <div
            :id="'description-tooltip' + resourceType + resourceData.id"
            class="d-flex"
          >
            <feather-icon
              icon="AlertCircleIcon"
              size="12"
              class="alert-icon--style"
            />
          </div>
          <b-tooltip
            :target="'description-tooltip' + resourceType + resourceData.id"
            placement="right"
            boundary="window"
            variant="primary"
          >
            <div class="description__container">
              {{ resourceData.description }}
            </div>
          </b-tooltip>
        </div>
        <div class="text--light text--small-size text--color-secondary">
          {{ resourceData.equipmentIp }}
        </div>
      </div>
      <div class="col-12 col-lg-7 pr-lg-0">
        <div class="d-flex w-100 h-100 align-items-center">
          <div
            class="progress--size"
          >
            <atom-bootstrap-progress-bar
              :color="resourceStatus"
              :value="parseFloat(resourceData.currentValue)"
            ></atom-bootstrap-progress-bar>
          </div>
          <div class="percent--width d-flex justify-content-end">
            <span
              class="text--extra-bold text--normal-size"
              :class="`text-${resourceStatus}`"
            >
              {{ resourceData.currentValue }} %</span
            >
          </div>
          <div class="alert--width alert__icon--padding">
            <div
              :id="'alert-icon' + resourceType + resourceData.id"
              class="d-flex justify-content-end"
            >
              <feather-icon
                :ref="'alert-icon' + resourceType + resourceData.id"
                icon="AlertTriangleIcon"
                class="alert__icon--active-style"
              />
            </div>
            <b-tooltip
              :target="'alert-icon' + resourceType + resourceData.id"
              placement="right"
              boundary="window"
              variant="warning"
            >
              <div class="textbox__warning-value--style">
                <span>Warning</span>
                <span>{{
                  resourceData.warningValue
                    ? resourceData.warningValue + " " + policyUnit
                    : "-"
                }}</span>
              </div>
              <div class="textbox__danger-value--style">
                <span>Critical</span>
                <span>{{
                  resourceData.criticalValue
                    ? resourceData.criticalValue + " " + policyUnit
                    : "-"
                }}</span>
              </div>
            </b-tooltip>
          </div>
        </div>
      </div>
    </div>
    <hr />
  </main>
</template>

<script>
import { BBadge, BPopover, VBTooltip, BTooltip } from "bootstrap-vue"
import Ripple from "vue-ripple-directive"
import AtomBootstrapProgressBar from "@/components/atoms/graphs/AtomBootstrapProgressBar.vue"
export default {
  components: { BBadge, BPopover, VBTooltip, BTooltip, AtomBootstrapProgressBar },
  directives: {
    "b-tooltip": VBTooltip,
    Ripple,
  },
  name: "MoleculeResourceCard",
  props: {
    resourceType: {
      type: String,
      required: true,
    },
    resourceData: {
      type: Object,
      required: true,
    },
  },
  computed: {
    resourceStatus() {
      if(this.resourceData.status === 0) return "primary"
      else if(this.resourceData.status === 1) return "warning"
      else return "danger"
    },
    policyUnit() {
      if (this.resourceData.policyUnit.toLowerCase() !== "percent") return this.resourceData.policyUnit
      else return "%"
    },
  },
}
</script>

<style lang="scss" scoped>
hr {
  margin-top: 10px;
  margin-bottom: 10px;
}

.text--extra-bold {
  font-weight: 700;
}

.text--bold {
  font-weight: 600;
}

.text--medium {
  font-weight: 500;
}

.text--light {
  font-weight: 400;
}

.text--normal-size {
  font-size: 12px;
}

.text--small-size {
  font-size: 10px;
}

.text--color-secondary {
  color: #b9b9c3;
}

.alert__icon--active-style {
  color: #b9b9c3;
}

.textbox__warning-value--style {
  display: flex;
  justify-content: space-between;
  color: #ff9f43;
  font-weight: 400;
  font-size: 14px;
}

.textbox__danger-value--style {
  display: flex;
  justify-content: space-between;
  color: #ea5455;
  font-weight: 400;
  font-size: 14px;
}

.text-percent--padding {
  padding: 0 5px 0 0;
}

.align--center {
  align-items: center;
}

.alert-icon--style {
  color: #b9b9c3;
  margin-left: 8px;
}

.description__container {
  text-align: left;
}

.padding__custom--value {
  padding: 7px 0;
}

.triangle-icon--padding {
  padding: 0 1rem 0 0;
}

.progress-bar--padding {
  padding: 0 0.5rem 0 1rem;
}

.alert__icon--padding {
  margin-left: 0.5rem;
  margin-right: 0;
}

.progress--size {
  width: 70%;
  height: 8px;
  margin-right: 0.5rem;
}
.percent--width {
  width: 20%;
}
.alert--width {
  width: 10%;
}
::v-deep .progress {
  height: 8px;
}

// Small devices (landscape phones, 576px and up)
@media screen and (min-width: 576px) {
}

// Medium devices (tablets, 768px and up)
@media screen and (min-width: 768px) {
  .progress-bar--padding {
    padding: 0 0.75rem 0 1rem;
  }
  .progress--size {
    width: 60%;
  }
  .percent--width {
    width: 30%;
  }
}

// Large devices (desktops, 992px and up)
@media screen and (min-width: 992px) {
  .text-percent--padding {
    padding: 0;
  }
  .padding__custom--value {
    padding: 4px 5px 0 0;
  }
  .progress-bar--padding {
    padding: 0 0.5rem 0 0;
  }
  .alert__icon--padding {
    margin-right: 1rem;
  }
  .progress--size {
    width: 40%;
  }
  .percent--width {
    width: 50%;
  }
}

// X-Large devices (large desktops, 1200px and up)
@media screen and (min-width: 1200px) {
  .progress--size {
    width: 45%;
  }
  .percent--width {
    width: 45%;
  }
}

// XXX-Large devices (1920px and up)
@media screen and (min-width: 1920px) {
  .progress--size {
    width: 60%;
  }
  .percent--width {
    width: 30%;
  }
}
</style>
